import * as React from "react";
import TabContent from "../insurance/components/tabContent";
import "./styles.scss";
import {imageBaseUrl} from "config";

const tipsContent = [
    {
        tabLabel: "Tips to Improve Your MyShubhLife Credit Score",
        content: [
            {
                image: `${imageBaseUrl}/img/icons/form1.png`,
                description: "Fill the optional details.",
            },
            {
                image: `${imageBaseUrl}/img/icons/smartphone-app.png`,
                description:  "Keep the MyShubhLife app installed.",
            },
            {
                image: `${imageBaseUrl}/img/icons/debit-card.png`,
                description: "Minimize cash withdrawal and use debit card often.",
            },
            {
                image: `${imageBaseUrl}/img/icons/cash.png`,
                description: "Pay bills on time.",
            },
            {
                image: `${imageBaseUrl}/img/icons/bank-transfer.png`,
                description: "Use bank to bank transfer instead of cash payment.",
            },
        ],
    },
];

export default class Tips extends React.Component<{}, {}> {
    public render() {
        return (
            <div className="container-fluid d-flex justify-content-center tips">
                <div className="col-md-4 mt-4">
                    <div className="text-center">
                        <img src={`${imageBaseUrl}/img/icons/tips.png`} alt="tips icon" className={"tips-hero-image mb-2"}/>
                    </div>
                    <div className="tips-content">
                        <TabContent details={tipsContent}/>
                    </div>
                </div>
            </div>
        );
    }
}
